import { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { format } from 'date-fns';
import Hero from './components/Hero';
import RateCard from './components/RateCard';
import Features from './components/Features';
import Testimonials from './components/Testimonials';
import CTA from './components/CTA';
import Footer from './components/Footer';

export default function HomePage() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-cream">
      <nav
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          scrolled ? 'bg-white shadow-md' : 'bg-white/10 backdrop-blur-sm'
        }`}
      >
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          <div className="flex items-center gap-2">
            <div className="w-10 h-10 flex items-center justify-center">
              <i className="ri-home-heart-line text-3xl text-navy"></i>
            </div>
            <span className="text-xl font-bold text-navy">Loans with Heena</span>
          </div>
          
          <div className="hidden md:flex items-center gap-8">
            <a href="#loans" className="text-gray-700 hover:text-navy transition-colors font-medium whitespace-nowrap cursor-pointer">
              Home Loans
            </a>
            <a href="#rates" className="text-gray-700 hover:text-navy transition-colors font-medium whitespace-nowrap cursor-pointer">
              Rates
            </a>
            <a href="#about" className="text-gray-700 hover:text-navy transition-colors font-medium whitespace-nowrap cursor-pointer">
              About Me
            </a>
            <a href="#resources" className="text-gray-700 hover:text-navy transition-colors font-medium whitespace-nowrap cursor-pointer">
              Resources
            </a>
          </div>
          
          <button className="bg-teal text-white px-6 py-2.5 rounded-lg font-medium hover:bg-teal/90 transition-colors whitespace-nowrap cursor-pointer">
            Get Pre-Qualified
          </button>
        </div>
      </nav>

      <Hero />
      <RateCard />
      <Features />
      <Testimonials />
      <CTA />
      <Footer />
    </div>
  );
}